import api from "./Api";

class AliquotaService {
  GetAliquota(payload) {
    return api.get("/v1/aliquota/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAliquota(payload) {
    return api.post("/v1/aliquota/", payload).then((response) => {
      return response.data;
    });
  }

  PutAliquota(payload) {
    return api.put("/v1/aliquota/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAliquota(payload) {
    return api.delete("/v1/aliquota/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAliquotaOData(payload) {
    return api.get("/OData/Aliquota" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AliquotaService();
